import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

import { ImageAd, MenuItem } from '@/lib/api/navigation/navigation.types'
import Text from '@/components/custom-ui/text'
import Link from 'next/link'
import SubmenuContent from '../shared/submenu-content'
import NavigationFooter from '../footer'

interface MobileMenuContentProps {
  menuItems: MenuItem[]
  imageAds: ImageAd[]
  setIsOpen: (isOpen: boolean) => void
}

const MobileMenuContent = ({
  menuItems,
  imageAds,
  setIsOpen,
}: MobileMenuContentProps) => {
  return (
    <div className={'w-full'}>
      <Accordion type="single" collapsible>
        {menuItems.map((item, index) => {
          return (
            <AccordionItem
              key={`NavigationItem${index}`}
              value={item.name}
              className="border-0"
            >
              {item.subitems?.length ? (
                <>
                  <AccordionTrigger
                    className="border-b-[0.3px] border-primary px-6 pb-0 pt-4 font-normal text-secondary-900 data-[state=open]:font-semibold"
                    iconClassName="text-primary-600"
                  >
                    <Text as="p" className="py-2">
                      {item.name}
                    </Text>
                  </AccordionTrigger>

                  <AccordionContent className="bg-gray-50">
                    <SubmenuContent
                      submenuItems={item.subitems}
                      isFooter={false}
                      imageAds={imageAds}
                      setIsOpen={setIsOpen}
                    />
                  </AccordionContent>
                </>
              ) : item.external ? (
                <a
                  className="flex flex-1 items-center justify-between border-b-[0.3px] border-primary px-6 py-4 pb-0 pt-4 text-secondary-900 transition-all hover:underline"
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setIsOpen(false)}
                >
                  <Text as="p" className="py-2">
                    {item.name}
                  </Text>
                </a>
              ) : (
                <Link
                  className="flex flex-1 items-center justify-between border-b-[0.3px] border-primary px-6 py-4 pb-0 pt-4 text-secondary-900 transition-all hover:underline"
                  href={item.url}
                  onClick={() => setIsOpen(false)}
                >
                  <Text as="p" className="py-2">
                    {item.name}
                  </Text>
                </Link>
              )}
            </AccordionItem>
          )
        })}
      </Accordion>

      <NavigationFooter imageAds={imageAds} />
    </div>
  )
}

export default MobileMenuContent
